import { render, staticRenderFns } from "./AnonCustomerForm.vue?vue&type=template&id=0ba24f84"
import script from "./AnonCustomerForm.vue?vue&type=script&lang=ts"
export * from "./AnonCustomerForm.vue?vue&type=script&lang=ts"
import style0 from "./AnonCustomerForm.vue?vue&type=style&index=0&id=0ba24f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports